import Registry from "./models/Registry";
import './components/Fadein';
import Menu from './components/MainMenu';
import GMap from './components/GMap.js';
import './components/LenisScroll';

class App {
  constructor(context) {
    this.registry = new Registry();
    this.registerComponents();
    this.initController(context);
    this.patchIos();
    this.setvh();
  }

  initController(contextData) {
    const Context = this.registry.getContext(contextData);
    new Context(contextData);
  }

  registerComponents() {
    this.registry
// ---- Componenti Caricati Staticamente ----
      // Registriamo direttamente la classe importata
      .addComponent('Menu', Menu)
      .addComponent('GMap',GMap)

      // ---- Componenti Caricati Dinamicamente ----
      // Registriamo una FUNZIONE che esegue l'import dinamico
      .addComponent('Slider', () => import("./components/Slider"))
      .addComponent('Accordion', () => import("./components/Accordion"))
      .addComponent('VimeoEmbed', () => import("./components/VimeoEmbed"))
      .addComponent('Modal', () => import("./components/Modal"))
      .addComponent('SliderText', () => import("./components/SliderText"))
      .addComponent('ColorText', () => import("./components/ColorText"))
      .addComponent('AnimationCard', () => import("./components/AnimationCard"))
      .addComponent('TextBenvenuti', () => import("./components/TextBenvenuti"))
      .addComponent('TitleAnimation', () => import("./components/TitleAnimation"))
      .addComponent('FiltroLavori', () => import("./components/FiltroLavori"))
      .addComponent('ModaleLavori', () => import("./components/ModaleLavori"))
      .addComponent('InfiniteScrollLavori', () => import("./components/InfiniteScrollLavori"))
      .addComponent('CustomCursor', () => import("./components/CustomCursor"))
    ;
  }

  patchIos() {
    window.addEventListener('resize', () => this.appHeight())
    this.appHeight()
  }

  appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  setvh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  
  
}

window.AppInit = function(context) {
    new App(context);
};
